import { useParams, useSearchParams } from "react-router-dom";
import api from "../../services/api";
import { useState } from "react";
import { confirmAlert } from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import "./emprestimo.css";
import api_cnpj from "../../services/api_cnpj";
import { formatar, mask } from "../../services/react-format";

function Emprestimo(props){
  const [searchParams    , setSearchParams]    = useSearchParams();

  const [cod_transacao   , setCodTransacao]= useState(-1);
  const [cont_id         , setContID]= useState(-1);
  const [trans_descr     , setTransDescr]= useState("");
  const [trans_dia_vencto, setTransDiaVencto]= useState("");
  const [trans_valor     , setTransValor]= useState(0);
  const [trans_status    , setTransStatus]= useState("");
  const [trans_num_parc  , setTransNumParc]= useState(1);
  const [alterado        , setAlterado]= useState(false);
  const [cont_cgc_cpf    , setContCgc_cpf]=useState("");
  const [cont_nome       , setContNome]=useState("");
  const [cont_endereco   , setContEndereco]=useState("");
  const [cont_numero     , setContNumero     ]=useState("");
  const [cont_complemento, setContComplemento]=useState("");
  const [cont_bairro     , setContBairro]=useState("");
  const [cont_cep        , setContCep]=useState("");
  const [cont_cidade     , setContCidade]=useState("");
  const [cont_uf         , setContUf]=useState("");
  const [cont_residencial, setContResidencial]=useState("");
  const [cont_email      , setContEmail]=useState("");

  var CNPJCliente    = searchParams.get("cnpj");
  var UsuarioSpartan = searchParams.get("usuario");  

  function handleValor(e){
    let obj = formatar(e.target,"money"); //target = objeto input que coloquei a funcao la em baixo
    console.log(obj)
    setTransValor(obj.value);
    setAlterado(true);    
  }
  function handleCnpj(e){
    let obj=formatar(e.target,"cnpjorcpf");
    setContCgc_cpf(obj.value);
    //  e.target.value.length>=13 ? PesquisaCNPJ(e.target.value):<></>
     setAlterado(true)    
  };

  function PesquisaCNPJ(cnpj, inputid){
    cnpj = cnpj.replaceAll("/","").replaceAll(".","").replaceAll("-","");
    //console.log(encodeURI(cnpj));
    if (cnpj == "") {
      console.log("CNPJ não informado"); 
      console.log("ID campo:"+ inputid); 
      return;
    };

    if (cnpj !== undefined) {
      api.get("/erp/lead",{params: {cnpj}})
      .then((resp) => {  //aguarda a resposta do comando get anterior          
        //console.log(JSON.stringify(resp.data));
        document.getElementById(inputid).value = resp.data.cont_nome;
        console.log("Pesquisa Lead retornou: " + resp.data.cont_nome);
        console.log("Campo alterado: " + inputid);
        setContCgc_cpf(resp.data.cont_cgc_cpf);
        setContNome(resp.data.cont_nome);
        setContEndereco(resp.data.cont_endereco);
        setContNumero(resp.data.cont_numero);
        setContComplemento(resp.data.cont_complemento);
        setContBairro(resp.data.cont_bairro);
        setContCep(resp.data.cont_cep);
        setContCidade(resp.data.cont_cidade);
        setContUf(resp.data.cont_uf);
        setContResidencial(resp.data.cont_residencial);
        setContEmail(resp.data.cont_email);      
      })
    .catch((err) => {     
                      //alert('Não foi possível encontrar os dados para este CNPJ') ;
                      setContCgc_cpf("");
                      setContNome("Não encontrado");
                      setContEndereco("");
                      setContNumero("");
                      setContComplemento("");
                      setContBairro("");
                      setContCep("");
                      setContCidade("");
                      setContUf("");
                      setContResidencial("");
                      setContEmail("");
                    }
          );

    if ((cont_nome == "")||(cont_nome == "Não encontrado"))
    {
      api_cnpj.get("/"+encodeURI(cnpj))
      .then((resp) => {  //aguarda a resposta do comando get anterior          
          //console.log(JSON.stringify(resp.data));
          console.log(resp.data.nome);
          setContCgc_cpf(resp.data.cnpj);
          setContNome(resp.data.nome);
          setContEndereco(resp.data.logradouro);
          setContNumero(resp.data.numero);
          setContComplemento(resp.data.complemento);
          setContBairro(resp.data.bairro);
          setContCep(resp.data.cep);
          setContCidade(resp.data.municipio);
          setContUf(resp.data.uf);
          setContResidencial(resp.data.telefone);
          setContEmail(resp.data.email);      
      })
      .catch((err) => {
          //alert('Não foi possível encontrar os dados para este CNPJ') ;
          setContCgc_cpf("");
          setContNome("Não encontrado");
          setContEndereco("");
          setContNumero("");
          setContComplemento("");
          setContBairro("");
          setContCep("");
          setContCidade("");
          setContUf("");
          setContResidencial("");
          setContEmail("");
      });
  
    } 
    else {
          setContCgc_cpf("");
          setContNome("");
          setContEndereco("");
          setContNumero("");
          setContComplemento("");
          setContBairro("");
          setContCep("");
          setContCidade("");
          setContUf("");
          setContResidencial("");
          setContEmail("");
        };
  
    };


  };

    
  function ExcluirEmprestimo(props){
    confirmAlert({
        title: 'Exclusão',
        message: 'Confirma exclusão? Valor:'+[props.trans_valor],
        buttons: [
          {
            label: 'Sim',
            onClick: (codtrans=props.id) => {              
              //console.log(props);
              api.delete("/erp/emprestimo?CNPJ="+CNPJCliente+"&usuario="+UsuarioSpartan+"&id="+codtrans)
              .then((resp) => {  //aguarda a resposta do comando get anterior
                //console.log(resp.data);
                if (resp.data.status == 'OK') {
                  props.onClose();
                }else{
                  alert(resp.data.mensagem);
                }
              })
              .catch((err) => {
                  alert('Falha ao excluir ID: '+props.cod_transacao + ' Mensagem: '+err) ;
              });
            }
            
          },
          {
            label: 'Não',
            onClick: () => {}
          }
        ]
      });
  };

  function SalvarEmprestimo(props){   
    console.log("Chamando função SalvarEmprestimo...");
    const emprestimo_params = {
      usuario: UsuarioSpartan,
      cod_transacao,
      cont_id,
      trans_descr,
      trans_dia_vencto,
      trans_status,
      trans_valor,
      trans_num_parc,
      cont_cgc_cpf,
      cont_nome,
      cont_endereco,
      cont_numero,
      cont_complemento,
      cont_bairro,
      cont_cep,
      cont_cidade,
      cont_uf,
      cont_residencial,
      cont_email
    };        
      if (cont_nome === "") {
        { 
          alert("Realize a pesquisa por CNPJ para preenchimento dos campos");
          return;
        }
      };
      console.log("trans_dia_vencto: " +trans_dia_vencto);
      if ((trans_dia_vencto === undefined)||(trans_dia_vencto === "")) {
        { 
          alert("Verifique o dia do mês do vencimento "+ trans_dia_vencto);
          return;
        }
      };
      if ((trans_valor === undefined) ||(trans_valor === 0)) {
        { 
          alert("Verifique o valor");
          return;
        }
      };


              console.log("chamando rota /erp/emprestimo");
              api.post("/erp/emprestimo?CNPJ="+CNPJCliente+"&usuario="+UsuarioSpartan,emprestimo_params)
              .then((resp) => {  //aguarda a resposta do comando get anterior
                console.log("Resp do post na rota /erp/emprestimo: "+resp.data);
                if (resp.status ===201){
                  //console.log(resp.data);
                  //alert('Emprestimo incluído. ID: '+resp.data.cod_transaacao);                      
                  props.onClose();
                  setAlterado(false);
                  setCodTransacao(-1);
                  setContID(-1);
                  setTransDescr("");
                  setTransDiaVencto(1);
                  setTransStatus("");
                  setTransNumParc(1);
                  setTransValor("");
                  setContCgc_cpf("");
                  setContNome("");
                  setContEndereco("");
                  setContNumero("");
                  setContComplemento("");
                  setContBairro("");
                  setContCep("");
                  setContCidade("");
                  setContUf("");
                  setContResidencial("");
                  setContEmail("");
            
                } else {alert("O seguinte erro foi retornado: "+resp.data.mensagem);}

              })
              .catch((err) => {
                  alert('Falha ao gravar dados: '+err);
              });

      // confirmAlert({
      //     title: 'Grava Dados',
      //     message: 'Confirma inclusão destes dados?',
      //     buttons: [
      //       {
      //         label: 'Sim',
      //         onClick: () => {
      //           console.log("chamando rota /erp/emprestimo");
      //           api.post("/erp/emprestimo?CNPJ="+CNPJCliente+"&usuario="+UsuarioSpartan,emprestimo_params)
      //           .then((resp) => {  //aguarda a resposta do comando get anterior
      //             console.log("Resp do post na rota /erp/emprestimo: "+resp.data);
      //             if (resp.status ==201){
      //               //console.log(resp.data);
      //               //alert('Emprestimo incluído. ID: '+resp.data.cod_transaacao);                      
      //               props.onClose();
      //               setAlterado(false);
      //               setCodTransacao(-1);
      //               setContID(-1);
      //               setTransDescr("");
      //               setTransDiaVencto("");
      //               setTransStatus("");
      //               setTransNumParc(1);
      //               setTransValor("");
      //               setContCgc_cpf("");
      //               setContNome("");
      //               setContEndereco("");
      //               setContNumero("");
      //               setContComplemento("");
      //               setContBairro("");
      //               setContCep("");
      //               setContCidade("");
      //               setContUf("");
      //               setContResidencial("");
      //               setContEmail("");
              
      //             } else {alert("O seguinte erro foi retornado: "+resp.data.mensagem);}

      //           })
      //           .catch((err) => {
      //               alert('Falha ao gravar dados: '+err);
      //           });

      //         }
      //       },
      //       {
      //         label: 'Não',
      //         onClick: () => {}
      //       }
      //     ]
      //   });
  };
  
  
    return <form className="row g-2 needs-validation mt-0 mb-0" noValidate id={"codtransid_"+props.id}>  
    {/* <div className="input-group" id={props.id}> */}
      <div className="col-md-4">
        <div className="input-group mb-3">
          {/* <MaskedInput              
             mascara="99.999.999/9999-99"
             value={props.cnpj}
             onChange={(event)=>setContCgc_cpf(event.target.value)}
             meuid={"cont_cnpj_emprestimo"+props.id}/> */}
          {/* <label for="cnpj" className="form-label">CNPJ</label> */}
          <input type="text" 
                 id={"cont_cnpj_emprestimo"+props.id} 
                 className="form-control"   
                 defaultValue ={props.cnpj}   
                 style={{"text-align": "center"}}               
                //  defaultValue ={(props.cnpj==11) ? mask("###.###.###-##",props.cnpj) : mask("##.###.###/####-##",props.cnpj)} 
                 onChange={handleCnpj}/>
                 {/* {formatar(document.getElementById("cont_cnpj_emprestimo"+props.id),"cnpjorcpf")} */}
          <button onClick={() => PesquisaCNPJ(document.getElementById("cont_cnpj_emprestimo"+props.id).value,"cont_nome_emprestimo"+props.id)} 
                  className="btn btn-outline-secondary btn-sm" 
                  type="button" id="button-addon2"><i className="bi bi-search"></i></button>
        </div>
      </div>
      <div className="col col-md-3" >
        <input type="text" id={"cont_nome_emprestimo"+props.id} className="form-control" maxLength="40"
               defaultValue ={props.cliente}
               onChange={(e) => setContNome(e.target.value)} 
        />
      </div>    
      <div className="col-md-1">       
        {/* <label for="vencimento" className="form-label">Vencimento</label> */}
        <input type="number"  min="1" max="31" id="vencimento" className="form-control" style={{"text-align": "center"}} defaultValue ={props.vencimento} onChange={(e) => {setTransDiaVencto(e.target.value); setAlterado(true)}}/>        
      </div>    
      <div className="col-md-1">
        {/* <label for="parcelas" className="form-label">Parcelas</label> */}
        <input type="number" min="1" max="500" id="parcelas" className="form-control"  style={{"text-align": "center"}} defaultValue ={props.parcelas} onChange={(e) => {setTransNumParc(e.target.value); setAlterado(true)}}/>
      </div>    
      <div className="col-md-2">
          <input
            type="text"
             id={"valor"+props.id}
             className="form-control"        
             defaultValue={props.valor}
            // defaultValue={new Intl.NumberFormat('pt-BR', {style: 'currency',currency: 'BRL'}).format(parseFloat(props.valor)/100)}
           //  decimalSeparator="," 
           //  groupSeparator="."
             //decimalsLimit={2}
             //intlConfig={{ locale: 'pt-BR', currency: 'BRL'}}
             onChange={handleValor}
             style={{"text-align": "right"}}/>        
        {/* <input type="text" id="valor" className="form-control" style={{"text-align": "right"}}  defaultValue ={props.valor} onChange={(e) => {setTransValor(e.target.value); setAlterado(true)}}/> */}
      </div>    
      <div className="col-md-1" id="div-botoes">
        {props.alterou || props.id<0 ?
          <button onClick={() => SalvarEmprestimo(props)} className="btn btn-primary btn-sm" type="button" id="button-salvar-emprestimo"><i className="bi bi-floppy"></i></button>
           :<></>}
        {props.id >= 0 ?
          <button onClick={() => ExcluirEmprestimo(props)} className="btn btn-danger btn-sm" type="button" id="button-excluir-emprestimo"><i className="bi bi-trash3-fill"></i></button>
           :<></>} 
      </div>    
    </form>

}

export default Emprestimo; 

